import React from 'react';
import PropTypes from 'prop-types';

import OffersV4Headline from './OffersV4Headline';
import OffersV4CardList from './OffersV4CardList';
import OffersV4LoanOfferDetails from './OffersV4LoanOfferDetails';
import OffersV4StickyCta from './OffersV4StickyCta';
import OffersV4ValueProps from './OffersV4ValueProps';
import OffersV4SocialProof from './OffersV4SocialProof';
import OffersV4Disclosure from './OffersV4Disclosure';
import OffersV4HelpContact from './OffersV4HelpContact';
import CreditCardReductionBanner from '../../banners/CreditCardReductionBanner';

const OffersV4DesktopLayout = ({
    maxOffer,
    minOffer,
    sliderAmount,
    selectedOfferId,
    isSelectingOffer,
    offersAtAmount,
    guidanceTags,
    counterOffer,
    counterOfferReportChanged,
    onAmountChange,
    onCardSelect,
    onContinue,
    onEditClick,
    isDialogOpen,
    onDialogClose,
    onDialogSubmit,
}) => (
    <div className="offers-v4-page--desktop">
        <CreditCardReductionBanner />
        <div className="offers-v4-desktop-content">
            <div className="offers-v4-left-panel">
                <div className="offers-v4-left-panel__content">
                    <OffersV4Headline
                        maxOffer={maxOffer}
                        counterOffer={counterOffer}
                        counterOfferReportChanged={counterOfferReportChanged}
                    />
                    <OffersV4LoanOfferDetails
                        amount={sliderAmount}
                        minOffer={minOffer}
                        maxOffer={maxOffer}
                        onAmountChange={onAmountChange}
                        onEditClick={onEditClick}
                        isDialogOpen={isDialogOpen}
                        onDialogClose={onDialogClose}
                        onDialogSubmit={onDialogSubmit}
                    />
                    <OffersV4CardList
                        offers={offersAtAmount}
                        guidanceTags={guidanceTags}
                        selectedOfferId={selectedOfferId}
                        onSelect={onCardSelect}
                    />
                    <OffersV4StickyCta
                        onContinue={onContinue}
                        disabled={!selectedOfferId || isSelectingOffer}
                        loading={isSelectingOffer}
                    />
                </div>
                <OffersV4Disclosure />
            </div>
            <div className="offers-v4-right-panel">
                <OffersV4HelpContact />
                <OffersV4ValueProps />
                <OffersV4SocialProof />
            </div>
        </div>
    </div>
);

OffersV4DesktopLayout.propTypes = {
    maxOffer: PropTypes.number.isRequired,
    minOffer: PropTypes.number.isRequired,
    sliderAmount: PropTypes.number.isRequired,
    selectedOfferId: PropTypes.string,
    isSelectingOffer: PropTypes.bool.isRequired,
    offersAtAmount: PropTypes.array.isRequired,
    guidanceTags: PropTypes.object.isRequired,
    counterOffer: PropTypes.bool,
    counterOfferReportChanged: PropTypes.bool,
    onAmountChange: PropTypes.func.isRequired,
    onCardSelect: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
};

export default OffersV4DesktopLayout;
